import { Nullable } from 'types';

export default class AnalyticsEvent {
  name: string;

  parameters: Nullable<{ [key: string]: unknown }>;

  constructor(name: string, parameters: Nullable<{ [key: string]: unknown }>) {
    this.name = name;
    this.parameters = parameters;
  }

  static createEvent(
    name: string,
    parameters: Nullable<{ [key: string]: unknown }> = null
  ): AnalyticsEvent {
    return new AnalyticsEvent(name, parameters);
  }
}
